import React, {Component} from 'react';
import './Main.scss';
import SideBar from "../../components/SideBar";
import {Route} from "react-router-dom";
import {routes, sidebar} from './routes'
import TopBar from "../../components/TopBar";
import {Redirect, RouteComponentProps, Switch} from "react-router";
import {connect} from 'react-redux';
import {
    ActionType, CHAINTYPES, reducerStoreType, ROLES, SOCKET_STATUS, storeType,
    userInfoType
} from "../../reducers/types";
import 'react-dates/initialize';
import '../../styles/react_dates_overrides.scss';
import {Dispatch} from "redux";
import AlertDialog from "../../components/CustomUIComp/AlertDialog";
import {injectIntl, IntlShape} from "react-intl";
import {CODES} from "../../constants";
import API from "../../api/api";

interface IProps extends RouteComponentProps<any>{
    userInfo: userInfoType | undefined,
    storeList: storeType[],
    dispatch: Dispatch<ActionType<any>>,
    currentStore: number,
    chainType: CHAINTYPES,
    socketStatus: SOCKET_STATUS,
    role: ROLES,
    intl: IntlShape
}

interface IState {
    alertOpen: boolean
}

class Main extends Component<IProps, IState> {
    constructor(props: IProps){
        super(props)
        this.state = {
            alertOpen: false
        }
    }
    getPage = (props: IProps) => {
        let pageNames = routes.map((item, i) => {
            return item.name
        })
        if(props.location){
            let urls = props.location.pathname.split('/')
            if(urls.length >=3 && urls[1] === 'app' && pageNames.indexOf(urls[2] ) > -1 ){
                return urls[2]
            }
        }
        return ''
    }
    isInfoInStorage = () => {
        let userInfo = localStorage.getItem('S4P_UserInfo')
        if (userInfo) {
            // localstorage 有数据
            console.log(userInfo)
            let userInfoJson = JSON.parse(userInfo)

            let params = {
                email: userInfoJson.email,
                clientId: 'h5'
            }
            API.checkIsLogin(params).then((response) => {
                if(response.code === CODES.SUCCESS){
                    if(response.data.logined === 1){
                        // 已登陆
                        let page =this.getPage(this.props)
                        this.props.dispatch({type: 'LOAD_MAIN', payload: {page}})
                    }else{
                        // 未登陆
                        this.props.history.replace('/login')
                    }
                }else{
                    // 检查登陆失败
                    this.props.history.replace('/login')
                }
            })
        }else{
            // localstorage无数据
            this.props.history.replace('/login')
        }
    }
    componentDidMount() {
        this.isInfoInStorage()
    }

    componentDidUpdate(prevProps:IProps) {
        let prevPage = this.getPage(prevProps)
        let currentPage = this.getPage(this.props)
        console.log("main did update:", prevPage, currentPage)

        if(prevPage !== currentPage){
            this.props.dispatch({type: 'LOAD_PAGE', payload: {page: currentPage}})
        }

    }

    handleStoreChange = (storeId: any) => {
        let page =this.getPage(this.props)
        if(page) {
            this.props.dispatch({type: 'TOP_BAR_CHANGE_STORE', payload: {page: page, storeId: storeId}})

        }
    }
    onLogout = () => {
        this.props.dispatch({type: 'LOGOUT', payload: undefined})
    }
    closeAlert = () => {
        this.setState({
            alertOpen: false
        })
    }
    confirmLogout = () => {
        this.setState({
            alertOpen: true
        })
    }
    onGetStoreList = () => {
        this.props.dispatch({type: 'GET_STORE_LIST', payload: undefined})
    }
    public render() {
        let {intl} = this.props
        return (
            <div className="Main">
                <SideBar navigationItems={sidebar}
                         role={this.props.userInfo ? this.props.userInfo.role : ROLES.NONE}/>
                <div className="right">
                    <TopBar userInfo={this.props.userInfo}
                            onLogout={this.confirmLogout}
                            socketStatus={this.props.socketStatus}
                            chainType={this.props.chainType}
                            currentStore={this.props.currentStore}
                            onStoreChange={this.handleStoreChange}
                            onGetStoreList = {this.onGetStoreList}
                            role={this.props.role}
                            storeList={this.props.storeList}/>
                    <div className="mainContent">
                        <Switch>
                            {routes && routes.map((route, index) => (
                                // Render more <Route>s with the same paths as
                                // above, but different components this time.
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.component}
                                />
                            ))}
                            <Redirect from="/app" exact to="/app/dashboard"/>
                        </Switch>
                    </div>
                </div>
                <AlertDialog open={this.state.alertOpen}
                             title={this.props.intl.formatMessage({id: 'logout'})}
                             content={intl.formatMessage({id: 'confirmLogoutMsg'})}
                             handleClose={this.closeAlert}
                             onConfirm={this.onLogout}/>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        userInfo: state.app.userInfo,
        socketStatus: state.app.socketStatus,
        storeList: state.merchant.storeList,
        currentStore: state.app.currentStore,
        chainType: state.merchant.merchantInfo.chainType,
        role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE
    }
})(Main));
